<template>
  <div class="activity-list">
    <template v-if="activityList && activityList.length > 0">
      <div style="min-height: 400px;margin-bottom:20px;">
        <Row :gutter="30">
          <Col span="6" v-for="(item, index) in activityList" :key="'act-' + index" class="w-20">
          <div class="activity-list-one">
            <div class="activity-imgbox">
              <div class="activity-imgbox-brand" v-if="typeList[item.topicType] && item.topicType !== 0">
                {{ typeList[item.topicType] }}
              </div>
              <div class="activity-imgbox-brand2" v-if="item.liveForbidTime">
                直播禁止到： {{item.liveForbidTime | moment("YYYY/MM/DD HH:mm")}}
              </div>
              <img v-if="item.banner && item.banner[0]" :src="item.banner[0]" />
              <img src="@/assets/img/empty.png" v-else />
              <div v-if="!item.isShow" class="product-show">
                                <i class="icon iconfont icon-hide"></i>
                            </div>
              
            </div>
            <div class="activity-name" :title="item.name">{{ item.name }}</div>
            <div class="activity-btn">
              <div class="txt" @click="linkTo(item)">编辑</div>
              <div class="activity-btn-line"></div>

              <!-- 没有申请直播 或者申请直播审核未通过 显示开启直播 -->
              <template v-if="!item.isApplyLive">
                <!-- 未开启直播状态 点击设置直播日期和直播具体时间 -->
                <div class="txt" @click="openInfo = item; open = true;" style="color:#2D8cF0">创建直播</div>
              </template>
              <template v-else-if="item.liveAudit === 'wait'">
                <!-- 未开启直播状态 点击设置直播日期和直播具体时间 -->
                <div class="txt" style="color:#ccc">开始直播</div>
              </template>
              <template v-else-if="item.liveAudit === 'pass'">
                <!-- 未开启直播状态 点击设置直播日期和直播具体时间 -->
                <div class="txt" @click="linkToLiveHanle(item)" style="color:#2D8cF0">开始直播</div>
              </template>

              <template v-else-if="item.liveAudit=='notpass'">
                <!-- 未开启直播状态 点击设置直播日期和直播具体时间 -->
                <div v-if=" item.liveChannelId"  @click="linkToLiveHanle(item)" style="color:#2D8cF0;"  class="txt">  开始直播</div>

                <div class="txt" @click="openInfo = item; open = true;" style="color:#2D8cF0" v-else>开始直播</div>

               </template>
                
              <template v-else>
                <!-- 开启直播状态 跳转道直播具体设置页面 -->
                <div class="txt" style="color:#ccc">开始直播</div>
              </template>

              <div class="activity-btn-line"></div>
              <div class="txt" @click="setTopic(item)">推荐</div>
              <div class="activity-btn-line"></div>
              <div class="txt">
                <Dropdown trigger="custom" :visible="item.visible">
                  <a href="javascript:void(0);" style="color:#808080;" @click="toggleOpen(index)">
                    更多
                    <Icon type="ios-arrow-down"></Icon>
                  </a>
                  <DropdownMenu slot="list" style="text-align:center;">
                    <!-- <DropdownItem @click.native="exportInfo(item)">下载名单</DropdownItem> -->
                    <DropdownItem @click.native="openLiveHandle(item)" v-if="item && item.liveForbidTime">开放直播</DropdownItem>
                    <DropdownItem @click.native="setLiveShow(item)" v-else>禁播</DropdownItem>
                    <DropdownItem v-if="item.isShow" @click.native="setShow(item)">屏蔽</DropdownItem>
                    <DropdownItem v-if="!item.isShow" @click.native="setUnShow(item)">显示</DropdownItem>
                    <DropdownItem>
                      <Poptip confirm placement="top-start" title="确认删除此活动吗 ?" @on-ok="delItem(item, index)" @on-cancel="handleClose(index)">
                        <div style="width: 100px;">删除</div>
                      </Poptip>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
            </div>
            <div class="activity-tag" v-if="item.liveAudit === 'notpass'">被驳回</div>
            <div class="activity-tag s-red" v-if="item.liveAudit === 'wait'">待审核</div>
          </div>
          </Col>
        </Row>

        <div class="my-page" v-if="totalCount > pageSize" style="text-align:center;">
          <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount" @on-change="changePage" @on-page-size-change="changePageSize" />
        </div>
      </div>
    </template>
    <div v-else style="line-height:500px;text-align:center;">暂无数据</div>

    <!-- 修改展商置顶 -->
    <exTopic :show="editTopic" v-if="editTopic" @finish="init()" :editTopicnfo="editTopicnfo" @close="editTopic = false; editTopicnfo = null;" />
    <!-- 直播禁播 -->
    <setLiveTime :show="liveShow" v-if="liveShow" @finish="init()" :info="liveShowInfo" @close="liveShow = false; liveShowInfo = null;" />
    <!-- 设置直播时间 -->
    <openLive :show="open" v-if="open" @finish="init()" :info="openInfo" @close="open = false; openInfo = null;" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import exTopic from "../components/ex-topic.vue";
import openLive from "../components/open-live.vue";
import setLiveTime from "../components/set-live-time.vue";

export default {
  name: "host-activity-list",
  props: {
    search: {
      type: String,
      default () {
        return "";
      }
    }
  },
  data () {
    return {
      open: false,
      openInfo: null,
      editTopic: false,
      editTopicnfo: null,

      liveShow: false,
      liveShowInfo: null,

      activityList: [], // 活动列表
      pageIndex: 1,
      pageSize: 12,
      totalCount: 0,
      typeList: [
        "不推荐",
        "推荐",
        "置顶",
      ],
    };
  },
  computed: {
    option () {
      return {
        ExhibitionId: this.exhibitionInfo.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "Name",
                  Value: `%${this.search}%`
                }
              }
            ]
          }
        }
      };
    },
    exhibitionInfo () {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  components: {
    exTopic,
    openLive,
    setLiveTime,
  },
  methods: {
    ...mapActions({
      getActByExId: "hostActModule/getActByExId",
      editActTopic: "hostActModule/editActTopic",
      editActShow: "hostActModule/editActShow",
      delActById: "hostActModule/delActById",
      updateLiveForbidTime: "liveModule/updateLiveForbidTime", // 直播禁止
    }),
    setTopic (item) {
      // 设置置顶
      this.editTopicnfo = item;
      this.editTopic = true;
    },
    async init () {
      let result = await this.getActByExId(this.option);
      if (result) {
        result.items.map(c => {
          if (c.banner) {
            c.banner = JSON.parse(c.banner);
          }
          c.visible = false;
        });
        this.activityList = result.items;
        this.pageSize = result.pageSize;
        this.pageIndex = result.pageIndex;
        this.totalCount = result.totalCount;
      }
    },
    changePage (e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize (e) {
      this.pageSize = e;
      this.init();
    },
    linkTo (item) {
      this.$router.push(`/host/index/act/act-edit?id=${item.id}`);
    },
    async setShow (item) {
      let req = {
        Id: item.id,
        IsShow: false
      };
      let result = await this.editActShow(req);
      if (result && result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    async setUnShow (item) {
      let req = {
        Id: item.id,
        IsShow: true
      };
      let result = await this.editActShow(req);
      if (result && result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    async delItem (item) {
      let result = await this.delActById(item.id);
      if (result && result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
      item.visible = false;
    },
    exportInfo (item) {
      console.log(item);
    }, 
    handleOpen (index) {
      this.activityList[index].visible = true;
    },
    handleClose (index) {
      this.activityList[index].visible = false;
    },
    toggleOpen (index) {
      let visible = this.activityList[index].visible;
      this.activityList[index].visible = !visible;
    },
    linkToLiveHanle (item) {
      this.$router.push(`/host/index/act/act-live?type=live&channelId=${item.liveChannelId}&activityId=${item.id}`)
    },
    setLiveShow (item) {
      // 设置置顶
      this.liveShowInfo = item;
      this.liveShow = true;
    },
    async openLiveHandle (row) {
      let req = {
        activityId: row.id,
        liveForbidTime: null,
      };
      let bool = await this.updateLiveForbidTime(req).catch(err => {
        this.loading = false;
      }); 
      if (bool && bool.data && bool.data.live && bool.data.live.updateLiveForbidTime) { 
        this.$Message.success("操作成功！");
        this.init();
      } else {
        let err = "操作失败，请重新尝试";
        if (bool.errors && bool.errors[0]) {
          err = bool.errors[0].message;
        }
        this.$Message.error(err);
      }
    },
  },
  created () {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.activity-list {
  min-width: 600px;
  padding: 30px 30px 100px 30px;

  &-one {
    background-color: #fff;
    margin-bottom: 20px;
    position: relative;

    .activity-imgbox {
      width: 100%;
      padding-bottom: 66.666667%;
      position: relative;

      img {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        max-height: 100%;
        z-index: 1;
      }

      &-brand {
        z-index: 2;
        position: absolute;
        top: 0;
        left: 0;
        padding: 3px 5px;
        color: #fff;
        background: #1890ff;
      }
      &-brand2 {
        z-index: 2;
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 3px 5px;
        color: #fff;
        background: #d13119;
        font-size: 12px;
      }
    }

    .activity-name {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 10px 10px;
    }

    .activity-tag {
      position: absolute;
      top: 0;
      right: 0;
      line-height: 20px;
      padding: 0 10px;
      font-size: 12px;
      color: #fff;
      background-color: #1890ff;
      z-index: 2;

      &.s-red {
        background-color: #d13119;
      }
    }

    .activity-btn {
      font-size: 14px;
      height: 48px;
      text-align: center;
      color: #808080;
      cursor: pointer;
      display: flex;
      align-items: center;

      .txt {
        display: inline-block;
        width: 32%;
      }

      &-line {
        display: inline-block;
        width: 1px;
        height: 30px;
        background-color: #e8e8e8;
        padding-top: 18px;
      }

      &-del {
        height: 34px;
        padding: 7px 16px;
        color: #333;

        &:hover {
          background: #f3f3f3;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}

.product-show {
        position: absolute;
        z-index: 1;
        right: 0;
        width: 0;
        height: 0;
        border-width: 20px;
        border-style: solid;
        border-color: #ccc #ccc transparent transparent;

        i {
            position: absolute;
            top: -25px;
            right: -20px;
            color: #fff;
            font-size: 25px;
        }
    }
</style>